export default __webpack_public_path__ + "static/media/cross.2fbf18d1.svg";